import React from 'react';

export default function Logo({ size = 'md' }) {
  const height = size === 'lg' ? 144 : 120;
  return (
    <img
      src="/logos/justicp.png"
      alt="JustICP"
      className="justicp-logo-img"
      style={{ height, width: 'auto', display: 'block' }}
    />
  );
}
